<template>
  <div>
    <b-row class='mt-2'>
      <b-col>
        <h4 v-if='item && item.type'>{{item.type.toUpperCase()}}</h4>
      </b-col>
    </b-row>
    <b-row class='mb-2'>
      <b-col>
        <label>Id rozdzielone przecinkami</label>
        <b-form-input
          :value='item.value.ids'
          @input='(e) => actions.handleItemYoutubeValueChanged(flatPage.id, item.id, "ids", e)'
        />
      </b-col>
    </b-row>
    <b-row class='mb-2'>
      <b-col>
        <label>Wysokość okna</label>
        <b-form-input
          :value='item.value.height'
          type='number'
          @input='(e) => actions.handleItemYoutubeValueChanged(flatPage.id, item.id, "height", e)'
        />
      </b-col>  
      <b-col>
        <label>Odstęp między filmami</label>
        <b-form-input
          type='number'
          :value='item.value.marginBottom'
          @input='(e) => actions.handleItemYoutubeValueChanged(flatPage.id, item.id, "marginBottom", e)'
        />
      </b-col>
      <b-col>
        <label>Zaokrąglenie</label>
        <b-form-input
          type='number'
          :value='item.value.borderRadius'
          @input='(e) => actions.handleItemYoutubeValueChanged(flatPage.id, item.id, "borderRadius", e)'
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>

  import {
    handleItemYoutubeValueChanged,
    handleItemTextStyleChanged,
  } from '@/store/utils.js'
  
  export default {
    props: ['flatPage', 'item'],
    computed: {
      marginBottom() {
        try {
          return this.item.style.marginBottom || 10
        } catch (e) {
          return 10
        }
      },
    },
    data() {
      return {
        actions: {
          handleItemYoutubeValueChanged,
          handleItemTextStyleChanged,
        },
      }
    },
  }
</script>
